import React from 'react';
import './SubscriptionOptions.css'; // Import your CSS file

const SubscriptionOptions = ({ selectedPlan, onSelectPlan }) => {
  const plans = [
    { id: 'BASIC', name: 'Basic 1 Note', price: '$4.99/month' },
    { id: 'STANDARD', name: 'Standard 5 Notes', price: '$9.99/month' },
    { id: 'PREMIUM', name: 'Premium 25 Notes', price: '$29.99/month' },
  ];

  return (
    <div className="subscription-options">
      {plans.map((plan) => (
        <label key={plan.id} className={`plan-card ${selectedPlan === plan.id ? 'selected' : ''}`}>
          <input
            type="radio"
            name="subscription-plan"
            value={plan.id}
            checked={selectedPlan === plan.id}
            onChange={() => onSelectPlan(plan.id)}
            className="plan-radio"
          />
          <div className="plan-content">
            <h3>{plan.name}</h3>
            <p>{plan.price}</p>
          </div>
        </label>
      ))}
    </div>
  );
};

export default SubscriptionOptions;